export default __webpack_public_path__ + "static/media/f-nakagawa.eca26037.webp";